
import { ApiOutlined, AppstoreAddOutlined, AuditOutlined, BankOutlined, ClusterOutlined, DoubleLeftOutlined, DoubleRightOutlined, GoogleOutlined, KeyOutlined, LockFilled, RocketOutlined, SafetyCertificateOutlined, SolutionOutlined, UnlockFilled, UserOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Layout as AntdLayout, Badge, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../store/AuthContext/AuthContext';
import { ConfigRoutes } from '../../../routing/UserRoutes';
import { useIsAuthorized, useModuleActive } from '../../pages/common/roles/Roles';

const { Sider, Content } = AntdLayout;
const grey = '#bab6b6';
const black = "#051235";

export const ConfigLayout = () => {

	const isAuthorized = useIsAuthorized();
	const location = useLocation();
  	const pathName = location.pathname;
	const { collapsed, setCollapsed } = useAuth();
	const isModuleActive = useModuleActive();
	const { t } = useTranslation();		

	return (
		<AntdLayout>			
			<Sider width={140} className='container-space' collapsed={collapsed} collapsible={true} trigger={null}>	
				<aside>
					<nav>
						<ul>	
							<Link to="/configurar/plan">
								<li className={`${(pathName == '/configurar/plan') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<RocketOutlined  style={{color: (pathName == '/configurar/plan') ? black : grey }} className='icon-menu-item'/>
										<span className={`${(pathName == '/configurar/plan') ? 'selected' : 'no-selected' }`}>Plan</span>
									</div>
								</li>
							</Link>
							{!isAuthorized(['ROLE_GUEST_VIEW']) &&
							<Link to="/configurar/invitados">
								<li className={`${(pathName == '/configurar/invitados') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<Badge offset={[10, 0]} count={isModuleActive('USERS') ? <UnlockFilled style={{ color: 'green' }} /> : <LockFilled style={{ color: 'crimson' }} />}>
											<UserOutlined style={{color: (pathName == '/configurar/invitados') ? black : grey }} className='icon-menu-item'/>
										</Badge>
										<span className={`${(pathName == '/configurar/invitados') ? 'selected' : 'no-selected' }`}>{t('subMenu.setup.users')}</span>
									</div>
								</li>
							</Link>							
							}
							{!isAuthorized(['ROLE_GUEST_VIEW']) &&
							<Link to="/configurar/permisos">
								<li className={`${(pathName == '/configurar/permisos') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<ClusterOutlined style={{color: (pathName == '/configurar/permisos') ? black : grey }} className='icon-menu-item'/>
										<span className={`${(pathName == '/configurar/permisos') ? 'selected' : 'no-selected' }`}>{t('subMenu.setup.groups')}</span>
									</div>
								</li>
							</Link>		
}						
						</ul>
					</nav>
				</aside>
			</Sider>
			
			<Content className='container-space'>
				<ConfigRoutes />				
			</Content>
			
		</AntdLayout>
	)
};
